import React from 'react';

import {GenericHookPaginatedList} from 'app/components/general/lists/GenericHookPaginatedList';
import {
  convertLocationParamsToFetchParams,
  useProcedures,
} from 'app/procedures/api';
import {CompactProcedureListItem} from 'app/procedures/components/CompactProcedureListItem';
import {useUserDetails} from 'app/user/api';
import {gt} from 'app/utils/i18n';

import type {
  ProceduresFetchParamsType,
  ProceduresLocationParamsType,
} from 'app/procedures/types';
import type {WithRouterProps} from 'react-router';
import type {ProcedureSerializedType} from 'sweet-types';

export const ProcedureList = (routerProps: WithRouterProps) => {
  const {data: user} = useUserDetails({id: routerProps.params.userid});

  return (
    <GenericHookPaginatedList<
      ProcedureSerializedType,
      ProceduresLocationParamsType,
      ProceduresFetchParamsType
    >
      {...routerProps}
      useDataHook={useProcedures}
      hookParams={{
        visible_to_user: routerProps.params.userid,
      }}
      convertParamsFunc={convertLocationParamsToFetchParams}
      renderItem={(procedure, refresh) => (
        <CompactProcedureListItem
          object={procedure}
          key={procedure.id}
          refreshData={refresh}
          enableBulkSelect={false}
          isSelected={false}
          addToSelection={() => null}
          removeFromSelection={() => null}
        />
      )}
      messages={{
        notFound: ({NoResultsMessage}) => (
          <NoResultsMessage
            head={
              user?.is_guest_until != null
                ? gt('Guests have no access to procedures')
                : gt("This member doesn't have access to any procedures")
            }
            icon="fas fa-user-clock"
          />
        ),
      }}
    />
  );
};
